import React, { useState, useEffect, useCallback } from "react";
import Alert from '@mui/material/Alert';
import Box from "@mui/material/Box";
import { red } from "../themePrimitives";


export default function useFadeOutAlert() {
    const [alertBanners, setAlertBanners] = useState([]);

    const deleteAlertBanner = useCallback((id) => {
        setAlertBanners(prevAlertBanners =>
            prevAlertBanners.filter((ab) => ab.props.id !== id)
        );
    }, []);

    const addAlertBanner = useCallback((text, type, duration) => {
        let key = crypto.randomUUID();
        let ab = (
            <AlertBanner
                text={text}
                type={type}
                displayFor={duration}
                id={key}
                key={key}
                deleteFunction={() => deleteAlertBanner(key)}
            />
        );
        setAlertBanners(prevAlertBanners => [ab, ...prevAlertBanners]);
    }, [deleteAlertBanner]);

    return {
        addAlertBanner,
        alertsContainer: (
            <Box sx={{
                display: 'flex',
                position: "fixed", // changed from "absolute"
                justifyContent: "center",
                zIndex: 1300, // higher to sit above dialogs/appbars
                top: 8,
                left: 0,
                width: '100%',
                pointerEvents: 'none', // optional: allows clicks through the container
            }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    padding: 1,
                    width: {
                        xs: '100%',
                        md: '60%',
                        lg: '40%',
                    },
                    pointerEvents: 'auto', // keep this for inner elements to be clickable
                }}>
                    {alertBanners}
                </Box>
            </Box>
        )
    };
}

function AlertBanner({
    text,
    type,
    displayFor = 3000,
    deleteFunction,
}) {
    const [isHidden, setIsHidden] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsHidden(true);
        }, displayFor);

        const timer2 = setTimeout(() => {
            deleteFunction();
        }, displayFor + 1000);
        return () => {
            clearTimeout(timer);
            clearTimeout(timer2);
        };
    }, [displayFor, deleteFunction]);


    return (
        <Alert
            severity={type}
            sx={{
                width: '100%',
                opacity: isHidden ? 0 : 1,
                transition: `opacity 1000ms ease-out`,
                // "& .MuiAlert-action": {
                //     alignItems: "center",
                //     paddingTop: "0px", 
                // },
                // "& .MuiSvgIcon-root": {
                //     color: red[400], 
                //     fontSize: "1.5rem", 
                // },
                // "& .MuiButtonBase-root":{
                //     backgroundColor: "transparent", 
                //     border:"none"
                // }
            }}
            onClose={deleteFunction}
        >
            {text}
        </Alert>
    );
}